import {Autocomplete, Button, CircularProgress, Stack, TextField, Typography} from '@mui/material';
import {useQuery} from 'react-query';
import {useFormik} from 'formik';
import * as Yup from 'yup';
import {request} from 'src/utils/AdminApi';
import {phoneValidation} from 'src/schema/authSchema';
import PhoneInput from 'src/components/inputs/PhoneInput';

const validationSchema = Yup.object({
	raw_city: Yup.string().required('يرجى اختيار المدينة'),
	raw_district: Yup.string().required('يرجى اختيار المنطقة'),
	raw_phone: phoneValidation,
});

export default function RawCreateShipment({order, provider, handleSubmit}) {
	const {data: providerCities = [], providerCitiesIsLoading} = useQuery(
		[provider, 'cities'],
		() => request(`/getProviderCities?provider=${provider}`),
		{
			refetchOnWindowFocus: false,
		},
	);

	const formik = useFormik({
		initialValues: {
			raw_city: '',
			raw_district: '',
			raw_phone: order?.customer?.phone || '',
		},
		validationSchema,
		onSubmit: (values) => {
			handleSubmit(provider, values);
		},
	});

	const {data: providerDistricts = [], isLoading: providerDistrictsIsLoading} = useQuery(
		[provider, 'districts', formik.values.raw_city],
		() => request(`/getProviderDistricts?provider=${provider}&cityId=${formik.values.raw_city}`),
		{
			refetchOnWindowFocus: false,
			enabled: !!formik.values.raw_city,
			onSuccess: (d) => {
				console.log('d', d);
				if (d.length > 0 && !formik.values.raw_district) {
					formik.setFieldValue('raw_district', d[0]?.id ?? '');
				}
			},
		},
	);

	if (providerCitiesIsLoading) return 'loading';

	return (
		<div>
			<Stack spacing={2} direction="column" justifyContent="space-between">
				<PhoneInput
					value={formik.values.raw_phone}
					onChange={(e) => formik.setFieldValue('raw_phone', e.target.value)}
					error={formik.touched.raw_phone && Boolean(formik.errors.raw_phone)}
					helperText={formik.touched.raw_phone && formik.errors.raw_phone}
				/>
				<Autocomplete
					size="small"
					fullWidth
					value={providerCities.find((c) => c.id === formik.values.raw_city) ?? null}
					onChange={(e, newValue) => {
						const cityId = newValue?.id ?? '';
						formik.setFieldValue('raw_city', cityId);
						formik.setFieldValue('raw_district', ''); // Reset district when city changes
					}}
					options={providerCities}
					getOptionLabel={(option) => option.name?.trim() || ''}
					isOptionEqualToValue={(option, value) => option?.id === value?.id}
					renderInput={(params) => (
						<TextField
							placeholder="اختر المدينة"
							label="المدينة"
							{...params}
							error={formik.touched.raw_city && Boolean(formik.errors.raw_city)}
							helperText={formik.touched.raw_city && formik.errors.raw_city}
						/>
					)}
				/>
				<Autocomplete
					size="small"
					fullWidth
					value={providerDistricts.find((c) => c.id === formik.values.raw_district) ?? null}
					onChange={(e, newValue) => {
						const districtId = newValue?.id ?? '';
						formik.setFieldValue('raw_district', districtId);
					}}
					options={providerDistricts}
					getOptionLabel={(option) => option.name || ''}
					isOptionEqualToValue={(option, value) => option?.id === value?.id}
					renderInput={(params) => (
						<TextField
							placeholder="اختر المنطقة"
							label="المنطقة"
							{...params}
							error={formik.touched.raw_district && Boolean(formik.errors.raw_district)}
							helperText={formik.touched.raw_district && formik.errors.raw_district}
						/>
					)}
					disabled={!formik.values.raw_city} // Disable until city is selected
				/>
				{providerDistrictsIsLoading && <CircularProgress />}
			</Stack>

			<Typography variant="body2" fontSize={12} p={0} mt={1}>
				العنوان الذي تم ادخاله من قبل: المدينة {order?.delivery_info?.city || ''} - المنطقة{' '}
				{order?.delivery_info?.district || ''}
			</Typography>

			{process.env.NODE_ENV === 'development' && (
				<Stack mt={2} spacing={3} direction="row">
					<p>city id: {formik.values.raw_city}</p>
					<p>district id: {formik.values.raw_district}</p>
				</Stack>
			)}
			<Button
				fullWidth
				sx={{mt: 2}}
				variant="contained"
				onClick={() => {
					formik.handleSubmit();
				}}
				disabled={!formik.dirty || formik.isSubmitting}
			>
				ارسال
			</Button>
		</div>
	);
}
